import React from 'react'
import { Route, Switch } from 'react-router'
import ReportCostTypeCosts from './ReportCostTypeCosts'

const Components = props => (
    <Switch>
        <Route exact path={`${props.match.url}/:year?`} component={ReportCostTypeCosts} />
    </Switch>
)

export default Components
